import { useEffect } from 'react';
import Navbar from '@components/Navbar';
import Hero from '@components/Hero';
import Features from '@components/Features';
import Trailer from '@components/Trailer';
import About from '@components/About';
import Testimonials from '@components/Testimonials';
import Footer from '@components/Footer';
import { NavLink } from './types';
import './styles/global.css';

function App() {
  // Navigation links data
  const navLinks: NavLink[] = [
    { id: 'hero', label: 'Home', href: '#hero' },
    { id: 'features', label: 'Features', href: '#features' },
    { id: 'trailer', label: 'Trailer', href: '#trailer' },
    { id: 'about', label: 'About', href: '#about' },
    { id: 'testimonials', label: 'Reviews', href: '#testimonials' }
  ];

  useEffect(() => {
    // Smooth scroll to top on page load
    window.scrollTo(0, 0);

    // Set document title
    document.title = 'Cosmos Horizon | Explore the Unknown. Conquer the Galaxy.';

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Embark on an epic space adventure in Cosmos Horizon. Explore infinite procedurally generated galaxies, engage in tactical space combat, and team up with players worldwide.');
    }
  }, []);

  return (
    <div className="App">
      {/* Skip to content link for accessibility */}
      <a href="#hero" className="skip-to-content">
        Skip to main content
      </a>

      {/* Navigation */}
      <Navbar navLinks={navLinks} />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <Hero />

        {/* Features Section */}
        <Features />

        {/* Trailer Section */}
        <Trailer />

        {/* About Section */}
        <About />

        {/* Testimonials Section */}
        <Testimonials />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
